import React from 'react'

const CheckboxComponent = ({ checked, text, setChecked, backgroundColor, color, borderColor }) => {

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked)
  }

  const boxStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: backgroundColor,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: 'normal',
  }

  const checkboxStyle = {
    width: '25px',
    height: '25px',
    backgroundColor: checked  ? "var(--secondary)" : backgroundColor,
    borderRadius: '8px',
    marginRight: '10px',
    position: 'relative',
    border: !checked  ? borderColor ? `1px solid ${borderColor}` : 'none' : "var(--secondary)"
  }

  const checkStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '15px',
    color: checked ? 'white' : color,
    display: checked ? 'block' : 'none',
  }

  return (
    <div style={boxStyle} onClick={() => setChecked(!checked)}>
      <div style={checkboxStyle}>
        <span style={checkStyle}>✔</span>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleCheckboxChange}
          style={{ display: 'none' }} // gizli checkbox
        />
      </div>
      <span className='checkbox-span'>{text}</span>
    </div>
  )
}

export default CheckboxComponent
